export default __webpack_public_path__ + "static/media/01_photo.ed905f3f.jpg";